import { createSlice } from "@reduxjs/toolkit";
import {
  fetchModifiers,
  createModifier,
  updateModifier,
  deleteModifier,
} from "../thunks/modifiersThunk";

const initialState = {
  modifiers: [],
  loading: false,
  error: null,
};

const modifiersSlice = createSlice({
  name: "modifiers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch modifiers
      .addCase(fetchModifiers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchModifiers.fulfilled, (state, action) => {
        state.loading = false;
        state.modifiers = action.payload;
      })
      .addCase(fetchModifiers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create modifier
      .addCase(createModifier.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createModifier.fulfilled, (state, action) => {
        state.loading = false;
        state.modifiers.push(action.payload);
      })
      .addCase(createModifier.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update modifier
      .addCase(updateModifier.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateModifier.fulfilled, (state, action) => {
        state.loading = false;
        state.modifiers = state.modifiers.map((mod) =>
          mod._id === action.payload._id ? action.payload : mod
        );
      })
      .addCase(updateModifier.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete modifier
      .addCase(deleteModifier.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteModifier.fulfilled, (state, action) => {
        state.loading = false;
        state.modifiers = state.modifiers.filter((mod) => mod._id !== action.payload);
      })
      .addCase(deleteModifier.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default modifiersSlice.reducer;
